<template>
  <el-dialog
    :visible.sync="internalVisible"
    :title="`${title}${isAdd ? '報價單' : '客戶資料'}`"
    top="5vh"
    width="30%"
    append-to-body
    show-close
    v-loading="loading"
    @closed="handleClosed"
  >
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div class="leader-data">
            <el-form ref="dynamicValidateForm" :model="formData" :disabled="!authEdit && !isAdd">
              <el-form-item
                label="負責業務員"
                :label-width="formLabelWidth"
                prop="saleerID"
                :rules="[{ required: true, message: '請選擇負責業務員', trigger: 'blur' }]"
              >
                <div style="display: flex">
                  <el-select
                    v-model="formData.saleerID"
                    filterable
                    placeholder="請選擇"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in saleerList"
                      :key="item.nickName"
                      :label="`${item.name} ${item.nickName ? `(${item.nickName})` : ''}`"
                      :value="item.id"
                    />
                  </el-select>
                  <el-button
                    type="warning"
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleCreateSaleer"
                    :loading="loading"
                  ></el-button>
                </div>
              </el-form-item>
              <el-form-item
                v-if="!isAdd && formData.travelerName"
                label="旅客名稱"
                :label-width="formLabelWidth"
                prop="travelerName"
                :rules="[{ required: true, message: '請輸入旅客名稱', trigger: 'blur' }]"
              >
                <el-input v-model="formData.travelerName" placeholder="請輸入旅客名稱" />
              </el-form-item>
              <el-form-item
                v-if="!isAdd && formData.travelerName"
                label="旅客職稱"
                :label-width="formLabelWidth"
                prop="travelerJob"
              >
                <el-input v-model="formData.travelerJob" placeholder="請輸入旅客職稱" />
              </el-form-item>
              <el-form-item
                v-if="!isAdd && formData.travelerName"
                label="公司名稱"
                :label-width="formLabelWidth"
                prop="companyName"
                :rules="[{ required: true, message: '請輸入公司名稱', trigger: 'blur' }]"
              >
                <el-input v-model="formData.companyName" placeholder="請輸入公司名稱" />
              </el-form-item>
              <el-form-item
                v-if="!isAdd && formData.travelerName"
                label="聯絡電話"
                :label-width="formLabelWidth"
                prop="tel"
              >
                <el-input v-model="formData.tel" placeholder="請輸入聯絡電話" />
              </el-form-item>
              <el-form-item
                v-if="!isAdd && formData.travelerName"
                label="E-mail"
                :label-width="formLabelWidth"
                prop="email"
              >
                <el-input v-model="formData.email" placeholder="請輸入 E-mail" />
              </el-form-item>
              <div v-if="!isAdd && !formData.travelerName" style="color: red">
                *此報價單尚未建立旅客資料，請先請旅客填寫表單後再進行客戶資料編輯操作。
              </div>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div slot="footer" class="dialog-footer">
      <el-button
        v-if="isAdd || authEdit"
        type="warning"
        style="color: #4b4b4b"
        @click="handleSubmitForm"
      >
        儲 存
      </el-button>

      <el-button :type="isAdd || authEdit ? '' : 'danger'" @click="internalVisible = false">
        {{ isAdd ? '取 消' : '關 閉' }}
      </el-button>
    </div>
    <saleer-create-or-update-dialog
      :visible.sync="dialogVisibleBySaleer"
      :initial-form-data.sync="formDataBySaleer"
      :is-add="true"
      :auth-edit="isAdmin"
      :agency-code="formData.agencyCode"
      @save="handleDialogSaveBySaleer"
      @closed="handleDialogCloseBySaleer"
    />
  </el-dialog>
</template>

<script>
import { getSaleers, saveAgencyTravelGroupQuote } from '@/api/agency'
import checkPermission from '@/utils/permission'
import SaleerCreateOrUpdateDialog from './SaleerCreateOrUpdateDialog.vue'

export default {
  components: { SaleerCreateOrUpdateDialog },
  name: 'GroupQuoteCreateOrUpdateDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    initialFormData: {
      type: Object,
      default: () => ({
        id: null,
        agencyCode: '',
        saleerID: '',
      }),
    },
    // 是否有編輯權限
    authEdit: {
      type: Boolean,
      default: true,
    },
    // 預設帶入的旅行社 Code
    agencyCode: {
      type: [String, Number],
      default: '',
    },
    formLabelWidth: {
      type: String,
      default: '110px',
    },
  },
  data() {
    return {
      loading: false,
      saleerList: [],
      formData: {
        id: null,
        saleerID: null,
        travelerName: '',
        travelerJob: '',
        companyName: '',
        tel: '',
        email: '',
      },
      formRules: {},
      title: '',
      isAdd: true,
      // 業務員Dialog
      dialogVisibleBySaleer: false,
      formDataBySaleer: {},
      isAdmin: this.checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF']),
    }
  },
  computed: {
    internalVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    visible: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.getSaleerOptions()
        }
      },
    },
    initialFormData: {
      immediate: true,
      async handler(val) {
        this.title = val && val.id ? '編輯' : '新增'
        this.isAdd = !(val && val.id)
        this.formData = Object.assign(
          {
            id: null,
            saleerID: null,
            travelerName: '',
            travelerJob: '',
            companyName: '',
            tel: '',
            email: '',
          },
          JSON.parse(JSON.stringify(val || {}))
        )
        this.formData.agencyCode = this.agencyCode
      },
    },
    async loading(newValue) {
      if (newValue && this.visible) {
        try {
          await this.$store.dispatch('app/showDownloadLoading', true)
          await this.$store.dispatch('app/showDownloadLoadingText', '資料處理中，請稍後')
        } catch (error) {
          await this.$store.dispatch('app/showDownloadLoading', false)
        }
      } else {
        await this.$store.dispatch('app/showDownloadLoading', false)
      }
    },
  },
  methods: {
    checkPermission,
    async getSaleerOptions() {
      this.loading = true
      await getSaleers({ agencyCode: this.agencyCode }).then(response => {
        this.saleerList = response.data
        this.loading = false
      })
    },
    handleSubmitForm() {
      this.$refs.dynamicValidateForm.validate(async valid => {
        if (valid) {
          await this.SaveGroupQuote().then(() => {
            this.$emit('save', { ...this.formData })
          })
        } else {
          return false
        }
      })
    },
    handleClosed() {
      if (this.$refs.dynamicValidateForm) {
        this.$refs.dynamicValidateForm.resetFields()
      }
      this.$emit('closed')
    },
    async SaveGroupQuote() {
      const messageTitle = this.formData.id ? '保存' : '新增'
      this.loading = true
      await saveAgencyTravelGroupQuote(this.formData)
        .then(res => {
          if (res.success) {
            this.$message({
              message: `${messageTitle}成功`,
              type: 'success',
            })
          }
        })
        .catch(error => {
          console.error(error)
          throw new Error(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleCreateSaleer() {
      this.formDataBySaleer = {}
      this.dialogVisibleBySaleer = true
    },
    async handleDialogSaveBySaleer() {
      await this.getSaleerOptions()
      this.dialogVisibleBySaleer = false
      this.formDataBySaleer = {}
    },
    async handleDialogCloseBySaleer() {
      this.dialogVisibleBySaleer = false
      this.formDataBySaleer = {}
    },
  },
}
</script>
